import { createSlice } from '@reduxjs/toolkit'
import { FAQs } from '../../../interfaces/FAQs'
import { getFAQs } from './faqsThunk';

interface FAQsState {
    faqs: FAQs[] | null;
    loading: "idle" | "pending" | "succeeded" | "failed";
}

const initialState: FAQsState = {
    loading: 'idle',
    faqs: null,
}

export const FAQsSlice = createSlice({
    name: 'FAQs',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getFAQs.pending, (state) => {
            state.loading = "pending";
        });
        builder.addCase(getFAQs.fulfilled, (state, action) => {
            state.loading = "succeeded";
            state.faqs = action.payload.FAQs;
        });
        builder.addCase(getFAQs.rejected, (state) => {
            state.loading = "failed";
        });
    }
})

export default FAQsSlice.reducer;